import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import PageTitle from 'components/_base/PageTitle';

import ContentQuery from './ContentQuery';

const App = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <PageTitle title="Consulta" />
      <hr />
      <ContentQuery />
      <Bottom />
    </div>
  );
};

export default App;
